import request from '@/utils/request'

// 人员轨迹分页
export function pagePersonnelTrajectory(query) {
  return request({
    url: '/system/user-stay-record/trajectory/page',
    method: 'get',
    params: query
  })
}
